import { Box, Grid, VStack, Heading, Text, Button } from '@chakra-ui/react';
import { differenceInDays } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Loader from 'components/Loader';
import { routePaths } from 'global/routePaths';
import { useFetchBillingDetails } from 'hooks/accountBilling/useFetchBillingDetails';
import { useCompanyInfo } from 'store/useUserStore';

const FreeTrial: React.FC<unknown> = () => {
  const { t } = useTranslation(['common', 'accountBilling']);

  const navigate = useNavigate();

  const companyInfo = useCompanyInfo();
  const timeDuration =
    companyInfo?.plan === 'Free Trial' && companyInfo?.valid_until
      ? differenceInDays(new Date(companyInfo?.valid_until), new Date())
      : null;

  const { status } = useFetchBillingDetails();

  if (status === 'loading') return <Loader />;

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <Box
        borderTop="4px"
        borderTopColor="primary.500"
        borderBottom="1px"
        borderBottomColor="gray.200"
        borderRight="1px"
        borderRightColor="gray.200"
        borderLeft="1px"
        borderLeftColor="gray.200"
        borderRadius="md"
        w="full"
      >
        <VStack w="full" h="full" alignItems="flex-start" px={6} pt={8} pb={24}>
          <Box display="flex" flexDirection="row" alignItems="center" mb="8px">
            <Heading as="h4" fontWeight="bold" fontSize="md" mb={{ base: '2', md: '0' }}>
              {t('accountBilling:youAreCurrentlyOnOurFreeTrialPlan')}
            </Heading>
            <Box border="1px" borderColor="gray.200" bg="gray.200" borderRadius={4} px={1} ml={2}>
              <Text color="gray.500" fontSize="xs">
                {timeDuration && timeDuration > 0
                  ? timeDuration === 1
                    ? `${timeDuration} ${t('accountBilling:daylLeftOnFreeTrial')}`
                    : `${timeDuration} ${t('accountBilling:daysLeftOnFreeTrial')}`
                  : 'Trial period over'}
              </Text>
            </Box>
          </Box>
          <Box pt={4} w="full">
            <Button
              colorScheme="secondary"
              py={6}
              px={20}
              w="full"
              borderRadius={4}
              onClick={() => navigate(routePaths.accountBilling.upgrade)}
            >
              {t('accountBilling:selectPlan')}
            </Button>
          </Box>
        </VStack>
      </Box>
    </Grid>
  );
};

export default FreeTrial;
